module.exports = __webpack_public_path__ + "img/twitter.301c64c2.svg";